import { createRouter, createWebHistory } from 'vue-router';

import appleWalletPass from '@/components/pages/apple-wallet-pass.vue';
import autoStartOrder from '@/components/pages/auto-start-order-page.vue';
import createAccount from '@/components/pages/create-account-page.vue';
import departmentList from '@/components/pages/hotel/department-list.vue';
import departmentSharePage from '@/components/pages/hotel/department-share-page.vue';
import departmentTippingPage from '@/components/pages/hotel/department-tipping-page.vue';
import employeeSharePage from '@/components/pages/hotel/employee-share-page.vue';
import employeeTippingPage from '@/components/pages/hotel/employee-tipping-page.vue';
import fourOhFour from '@/components/pages/four-oh-four-page.vue';
import genericWrapper from '@/components/pages/wrapper-page.vue';
import locationList from '@/components/pages/location-list-page.vue';
import makeAPayment from '@/components/pages/make-a-payment-page.vue';
import orderAtTableSelectOrder from '@/components/pages/order-at-table/select-order-page.vue';
import orderGiftingRedemption from '@/components/pages/order/gifting-redemption-page.vue';
import orderOffers from '@/components/pages/order/offers-page.vue';
import parentLanding from '@/components/pages/parent-landing-page.vue';

import readOnlyMenu from '@/components/pages/read-only-menu-page.vue';
import signIn from '@/components/pages/sign-in-page.vue';
import termsAndConditions from '@/components/pages/terms-and-conditions-page.vue';
import tipReceiptPage from '@/components/pages/hotel/tip-receipt-page.vue';
import welcome from '@/components/pages/welcome-page.vue';
import AppDownloadPage from '@/components/pages/landing-pages/app-download-page.vue';

// Route Guards
import routerBeforeEach from '@/helpers/router-before-each';
import routerBeforeEnterPaymentPage from '@/helpers/router-before-enter-payment-page';
import routerBeforeEnterGiftCardGifting from '@/helpers/router-before-enter-gift-card-gifting';
import routerBeforeEnterOrderHistory from '@/helpers/router-before-enter-order-history';
import routerBeforeEnterFavorites from '@/helpers/router-before-enter-favorites';
import routerBeforeEnterAppDownloadPage from '@/helpers/router-before-enter-app-download-page';
import routerBeforeEnterInbox from '@/helpers/router-before-enter-inbox';
import scrollBehavior from '@/helpers/scroll-behavior';


// Layouts
import MerchantLayout from '@/view/layout/merchant-layout/index.vue';
import OrderAheadLayout from '@/view/layout/order-ahead-layout/index.vue';
import OrderAtTableLayout from '@/view/layout/order-at-table-layout/index.vue';
import PayAtTableLayout from '@/view/layout/pay-at-table-layout/index.vue';

// Order Ahead Pages
import OrderAheadMenuPage from '@/view/pages/order-ahead/menu-page/index.vue';
import OrderAheadCheckoutSummaryPage from '@/view/pages/order-ahead/checkout-summary-page/index.vue';
import JoinGroupOrderPage from '@/view/pages/order-ahead/join-group-order-page/index.vue';
import PaymentPage from '@/view/pages/order-ahead/payment-page/index.vue';
import OrderReceiptPage from '@/view/pages/order-ahead/order-receipt-page/index.vue';
import MyAccountPage from '@/view/pages/order-ahead/my-account-page/index.vue';
import ContactUsPage from '@/view/pages/order-ahead/contact-us-page/index.vue';
import OrderHistoryPage from '@/view/pages/order-ahead/order-history-page/index.vue';
import SendGiftCardPage from '@/view/pages/order-ahead/send-gift-card-page/index.vue';
import PaymenMethodsPage from '@/view/pages/order-ahead/payment-methods-page/index.vue';
import CreditCardsPage from '@/view/pages/order-ahead/payment-methods-page/credit-cards-page/index.vue';
import GiftCardsPage from '@/view/pages/order-ahead/payment-methods-page/gift-cards-page/index.vue';
import ScanAndPayPage from '@/view/pages/order-ahead/scan-and-pay-page/index.vue';
import ScanToPayPage from '@/view/pages/order-ahead/scan-and-pay-page/scan-to-pay-page/index.vue';
import ScanOnlyPage from '@/view/pages/order-ahead/scan-and-pay-page/scan-only-page/index.vue';
import GiftCardScanningPage from '@/view/pages/shared/gift-card-scanning-page/index.vue';
import FavoriteOrdersPage from '@/view/pages/order-ahead/favorite-orders-page/index.vue';
import InboxPage from '@/view/pages/order-ahead/inbox-page/index.vue';
import LoyaltyPage from '@/view/pages/order-ahead/loyalty-page/index.vue';
import LoyaltyActivityPage from '@/view/pages/order-ahead/loyalty-activity-page/index.vue';

// Order At Table Pages
import OrderAtTableMenuPage from '@/view/pages/order-at-table/menu-page/index.vue';
import OrderAtTableCartSummaryPage from '@/view/pages/order-at-table/cart-summary-page/index.vue';
import TableTopWelcomPage from '@/view/pages/order-at-table/table-top-welcome-page/index.vue';

// Pay At Table Pages
import PayAtTableCheckout from '@/view/components/pay-at-table/checkout-page/index.vue';
import PayAtTableReceipt from '@/view/components/pay-at-table/receipt-page/index.vue';
import PayAtTableSelectOrder from '@/view/components/pay-at-table/select-order-page/index.vue';

// Shared Pages
/** Note: MenuItemDetailsPage and CheckGiftCardBalanceWrapper are wrappers that handle rendering modals */
import CheckGiftCardBalanceWrapper from '@/view/pages/shared/check-gift-card-balance-wrapper/index.vue';
import MenuItemDetailsPage from '@/view/pages/shared/menu-item-detail-page/index.vue';
import FaqPage from '@/view/pages/shared/faq-page/index.vue';

// Helper function for temporary route redirects
const createRedirect = newPath => to => ({
  path: newPath.replace(':merchantId', to.params.merchantId),
  query: to.query,
  hash: to.hash,
  params: { ...to.params }
});

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:merchantId/order',
      name: 'order',
      component: OrderAheadLayout,
      redirect: {
        name: 'orderMenu'
      },
      children: [
        {
          path: 'menu',
          name: 'orderMenu',
          component: OrderAheadMenuPage,
          children: [
            {
              path: 'check-balance',
              name: 'checkGiftCardBalance',
              component: CheckGiftCardBalanceWrapper
            },
            {
              path: ':menuItemId',
              name: 'orderAheadMenuItemDetailsPage',
              component: MenuItemDetailsPage
            }
          ]
        },
        {
          path: 'order-ahead-summary',
          name: 'orderAheadCheckoutSummaryPage',
          component: OrderAheadCheckoutSummaryPage,
          meta: { hideCartButton: true, hideSignInButton: true },
          props: true
        },
        {
          path: 'payment',
          name: 'paymentPage',
          component: PaymentPage,
          beforeEnter: routerBeforeEnterPaymentPage,
          meta: { hideCartButton: true, hideSignInButton: true },
          props: true
        },
        {
          path: 'favorites',
          name: 'orderFavorites',
          component: FavoriteOrdersPage,
          meta: { requiresAuth: true },
          beforeEnter: routerBeforeEnterFavorites
        },
        {
          path: 'gifting',
          name: 'orderGifting',
          component: SendGiftCardPage,
          beforeEnter: routerBeforeEnterGiftCardGifting
        },
        {
          path: 'inbox',
          name: 'inbox',
          component: InboxPage,
          beforeEnter: routerBeforeEnterInbox
        },
        {
          path: 'redeem-gift-card',
          name: 'orderGiftingRedemption',
          component: orderGiftingRedemption
        },
        {
          path: 'join-group/:groupToken',
          name: 'orderJoinGroupOrder',
          component: JoinGroupOrderPage
        },
        {
          path: 'loyalty/point-gift-claims',
          redirect: { name: 'order' }
        },
        {
          path: 'single-scan-barcode',
          name: 'singleScanBarcode',
          component: ScanAndPayPage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'scan-to-pay',
              name: 'scanToPay',
              component: ScanToPayPage
            },
            {
              path: 'scan-only',
              name: 'scanOnly',
              component: ScanOnlyPage
            }
          ]
        },
        {
          path: 'gift-card-payment-scanning',
          name: 'GIFT_CARD_PAYMENT_SCANNING',
          component: GiftCardScanningPage,
          meta: { requiresAuth: true }
        },
        {
          path: 'receipt/:receiptToken',
          name: 'orderReceipt',
          component: OrderReceiptPage
        },

        // ==================================================
        // TEMPORARY REDIRECTS - TODO: Remove after migration
        // Old routes: /:merchantId/order/* → New routes: /:merchantId/*
        // ==================================================
        {
          path: 'my-account',
          redirect: createRedirect('/:merchantId/my-account')
        },
        {
          path: 'offers',
          redirect: createRedirect('/:merchantId/offers')
        },
        {
          path: 'loyalty-activity',
          redirect: createRedirect('/:merchantId/loyalty-activity')
        },
        {
          path: 'order-history',
          redirect: createRedirect('/:merchantId/order-history')
        },
        {
          path: 'loyalty',
          redirect: createRedirect('/:merchantId/loyalty')
        },
        {
          path: 'payment-methods',
          redirect: createRedirect('/:merchantId/payment-methods'),
          children: [
            {
              path: 'credit-cards',
              redirect: createRedirect('/:merchantId/payment-methods/credit-cards')
            },
            {
              path: 'gift-cards',
              redirect: createRedirect('/:merchantId/payment-methods/gift-cards')
            }
          ]
        }
        // ==================================================
        // END TEMPORARY REDIRECTS
        // ==================================================
      ]
    },

    {
      path: '/:merchantId/order-at-table',
      name: 'orderAtTable',
      component: OrderAtTableLayout,
      redirect: {
        name: 'orderAtTableSelectOrder'
      },
      children: [
        {
          path: 'select-order',
          name: 'orderAtTableSelectOrder',
          component: orderAtTableSelectOrder
        },
        {
          path: 'menu',
          name: 'orderAtTableMenu',
          component: OrderAtTableMenuPage,
          children: [
            {
              path: ':menuItemId',
              name: 'orderAtTableMenuItemDetailsPage',
              component: MenuItemDetailsPage
            }
          ]
        },
        {
          path: 'order-at-table-summary',
          name: 'orderAtTableCartSummaryPage',
          component: OrderAtTableCartSummaryPage
        },
        {
          path: 'table-top-welcome',
          name: 'tableTopWelcomePage',
          component: TableTopWelcomPage
        }
      ]
    },

    {
      path: '/:merchantId/pay-at-table',
      name: 'payAtTable',
      component: PayAtTableLayout,
      redirect: {
        name: 'payAtTableSelectOrder'
      },
      children: [
        {
          path: 'select-order',
          name: 'payAtTableSelectOrder',
          component: PayAtTableSelectOrder
        },
        {
          path: 'checkout',
          name: 'payAtTableCheckout',
          component: PayAtTableCheckout
        },
        {
          path: 'receipt/:receiptToken',
          name: 'payAtTableReceipt',
          component: PayAtTableReceipt
        }
      ]
    },

    {
      path: '/:merchantId',
      component: MerchantLayout,
      name: 'merchant',
      children: [
        // Merchant Utils
        {
          path: 'locations',
          name: 'locations',
          component: locationList
        },
        {
          path: 'my-account',
          name: 'myAccount',
          component: MyAccountPage,
          meta: { requiresAuth: true }
        },
        {
          path: 'offers',
          name: 'offers',
          component: orderOffers,
          meta: { requiresAuth: true }
        },
        {
          path: 'loyalty-activity',
          name: 'loyaltyActivity',
          component: LoyaltyActivityPage,
          meta: { requiresAuth: true }
        },
        {
          path: 'order-history',
          name: 'orderHistory',
          component: OrderHistoryPage,
          meta: { requiresAuth: true },
          beforeEnter: routerBeforeEnterOrderHistory
        },
        {
          path: 'loyalty',
          name: 'loyalty',
          component: LoyaltyPage,
          meta: { requiresAuth: true }
        },
        {
          path: 'payment-methods',
          alias: 'saved-cards',
          name: 'paymentMethods',
          component: PaymenMethodsPage,
          meta: { requiresAuth: true },
          children: [
            {
              path: 'credit-cards',
              name: 'paymentMethodsCreditCards',
              component: CreditCardsPage
            },
            {
              path: 'gift-cards',
              name: 'paymentMethodsGiftCards',
              component: GiftCardsPage
            }
          ]
        },
        {
          path: 'contact-us',
          name: 'contactUs',
          component: ContactUsPage
        },
        {
          path: 'faqs',
          name: 'faqs',
          component: FaqPage
        },
        {
          path: 'make-a-payment',
          name: 'makeAPayment',
          component: makeAPayment
        },
        {
          path: 'menu',
          name: 'readOnlyMenu',
          component: readOnlyMenu
        },
        {
          path: 'terms-and-conditions',
          alias: 'end-user-terms',
          name: 'termsAndConditions',
          component: termsAndConditions
        },
        {
          path: 'app-download',
          name: 'appDownloadPage',
          beforeEnter: routerBeforeEnterAppDownloadPage,
          component: AppDownloadPage
        },
        // Hotel Utils
        {
          path: 'mobile-tipping/receipt/:receiptToken?',
          name: 'tipReceiptPage',
          component: tipReceiptPage,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        },
        {
          path: 'departments',
          name: 'departmentList',
          component: departmentList,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        },
        {
          path: 'departments/:departmentId',
          name: 'departmentTipping',
          component: departmentTippingPage,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        },
        {
          path: 'departments/:departmentId/share',
          name: 'departmentShare',
          component: departmentSharePage,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        },
        {
          path: 'employees/:employeeId',
          name: 'employeeTipping',
          component: employeeTippingPage,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        },
        {
          path: 'employees/:employeeId/share',
          name: 'employeeShare',
          component: employeeSharePage,
          meta: {
            headerLogoRoute: 'departmentList'
          }
        }
      ]
    },

    {
      path: '/:merchantId',
      name: 'generic',
      component: genericWrapper,
      children: [
        {
          path: 'apple-wallet-pass',
          name: 'appleWalletPass',
          component: appleWalletPass
        },
        {
          path: 'create-account',
          name: 'createAccount',
          component: createAccount
        },
        {
          path: 'landing/:token',
          name: 'parentLanding',
          component: parentLanding
        },
        {
          path: 'sign-in',
          name: 'signIn',
          component: signIn
        },
        {
          path: 'start-order',
          name: 'autoStartOrder',
          component: autoStartOrder
        },
        {
          path: 'welcome',
          name: 'welcome',
          component: welcome
        }
      ]
    },

    {
      path: '/:pathMatch(.*)*',
      name: 'fourOhFour',
      component: fourOhFour
    }
  ],
  scrollBehavior
});



router.beforeEach(routerBeforeEach);



export default router;
